import Vue from "vue";
import VueRouter, { RawLocation, Route, RouteConfig } from "vue-router";
import { AuthService } from "@/services/auth.service";
import { TestModule } from "@/store/test.module";
import { AuthModule } from "@/store/auth.module";

// catching errors
const originalPush = VueRouter.prototype.push as (
  location: RawLocation,
) => Promise<Route>;
VueRouter.prototype.push = async function (location: RawLocation) {
  return originalPush.call(this, location).catch(err => {
    if (err.name == "NavigationDuplicated") return err;
    throw err;
  });
};

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    meta: {
      isPublic: false,
    },
    component: () => import("@/views/App/AppMain.vue"),
    children: [
      {
        name: "contracts",
        path: "/contracts",        
        component: () => import("@/views/Contracts.vue"),
        meta: {
          isPublic: false,
        },
      },
      {
        name: "newcontract",
        path: "/newcontract",        
        component: () => import("@/views/NewContract.vue"),
        meta: {
          isPublic: false,
        },
      },
      {
        name: "editcontract",
        path: "/newcontract/:id",        
        component: () => import("@/views/NewContract.vue"),
        meta: {
          isPublic: false,
        },
      },
      {
        name: "attachments",
        path: "/attachments/:id",        
        component: () => import("@/views/Attachments.vue"),
        meta: {
          isPublic: false,
        },
      },
      {
        name: "plan",
        path: "/plan/:id",        
        component: () => import("@/views/Plan.vue"),
        meta: {
          isPublic: false,
        },
      },
    ]
  },
  {
    path: "/auth",
    component: () => import("@/views/Auth/AuthView.vue"),
    meta: {
      isPublic: true,
      onlyWhenLoggedOut: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  TestModule.setEdsCheckDisabled(to.query.debug !== undefined);

  const hasToken = AuthService.hasToken();
  const isPublic = to.matched.some(record => record.meta.isPublic);
 
  // has token and route isn't defined (issue when redirecting from esalmaty)
  if (hasToken && !to.name) {
    await AuthModule.getUser();
    if (AuthModule.user) {
      return next({ path: "/contracts" });
    }

    return next({ path: "/auth" });
  }

  // has no local token & is on a public path
  if (!hasToken && !isPublic) {
    return next({
      path: "/auth",
    });
  }

  // yandex metrika
  //window.ym(70323007, "hit", to.path);

  next();
});

export default router;
